export const getCartItems = () => {
    return JSON.parse(localStorage.getItem('cartItems')) || [];
  };
  
  export const setCartItems = (items) => {
    localStorage.setItem('cartItems', JSON.stringify(items));
    window.dispatchEvent(new Event('storage'));
  };
  
  export const clearCartItems = () => {
    localStorage.removeItem('cartItems');
    window.dispatchEvent(new Event('storage'));
  };